import { LocalDate, maybe } from "@flockcover/flock-svc-core-types"
import * as t from "io-ts"

const EmbeddedVehicle = t.type({
  manufacturer: t.string,
  model: t.string,
  abiGroup: maybe(t.number),
})

export const EmbeddedMotorVehicleType = t.type({
  registrationNumber: t.string,
  onCoverDate: LocalDate,
  offCoverDate: maybe(LocalDate),
  vehicle: EmbeddedVehicle,
})

export const InsightVehicleType = t.type({
  averageSpeedExceedencePercentage: t.string,
  distance: t.number,
  distanceSpentSpeedingPercentage: t.string,
  name: t.string,
  score: maybe(t.number),
  scoreChange: maybe(t.number),
  vrn: t.string,
})

export type EmbeddedMotorVehicle = t.TypeOf<typeof EmbeddedMotorVehicleType>
export type InsightVehicle = t.TypeOf<typeof InsightVehicleType>
